import APIClient from './client'
import { camelizeKeys } from 'humps'

const getSystemUsers = () => {
  return APIClient().get('/v1/system_users')
    .then( response => camelizeKeys(response.data))
}

const systemUsersAPI = {
  getSystemUsers
}

export default systemUsersAPI
